import createMatchListPage from "../components/MatchListPage";

export default createMatchListPage({
  // title: "Bureau Profiles",
  getEndpoint: ({ gender, status, filter }) => {
    const base = status
      ? `/bureau/profiles/${gender}/${status}`
      : `/bureau/profiles/${gender}`;

    const qs = new URLSearchParams();
    if (filter) qs.set("filter", filter);

    const q = qs.toString();
    return q ? `${base}?${q}` : base;
  },
  getHeaderTitle: ({ gender, status, filter }) => {


    const formatLabel = (value?: string) => {
      if (!value) return "";
      const normalized = value.replace(/[_-]+/g, " ").trim();
      if (!normalized) return "";
      return normalized
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    };

    const filterLabelMap: Record<string, string> = {
      private: "Private",
      inactive: "New",
      active: "Active",
      pending: "Incomplete",
      free: "Interested Profiles For Visiting",
      paid: "Paid",
      redzone: "Red Zone",
      red_zone: "Red Zone",
      "red-zone": "Red Zone",
      createdbyothermediator: "You added by Other Bureau",
    };

    const statusLabelMap: Record<string, string> = {
      pending: "Incomplete",
      direct: "Direct Registered",
    };

    const normalizedGender = String(gender || "").toLowerCase();
    const normalizedFilter = String(filter || "").toLowerCase();
    const genderLabel =
      normalizedGender === "all" ? "" : formatLabel(gender);
    const statusLabel =
      statusLabelMap[String(status || "").toLowerCase()] || formatLabel(status);
    const filterLabel = filterLabelMap[normalizedFilter] || formatLabel(filter);

    if (normalizedFilter === "createdbyothermediator") {
      return "You added by Other Bureau Profiles";
    }

    if (filterLabel) {
      if (normalizedFilter === "free") {
        return `${filterLabel} ${genderLabel}`.trim();
      }
      
      return `${filterLabel} ${genderLabel} Profiles`.trim();
    }
    if (statusLabel) {
      return `${statusLabel} ${genderLabel} Profiles`.trim();
    }
    return `${genderLabel} Profiles`.trim();
  },
  getGenderSwitchPath: (params, genderKey) => {
    if (params.status !== "direct") return undefined;
    return `/admin/profiles/${genderKey}/direct`;
  },
  hideCounterFilters: (params) => params.status === "direct",
  buildExtraActions: ({ match, updateFollowUpStatus, endpoint }) => {
    if (
      endpoint.includes("filter=callback") ||
      endpoint.includes("filter=not_responding") ||
      endpoint.includes("/direct")
    ) {
      return [];
    }

    return [
      {
        id: "callback",
        label: "Move to Call Back",
        onClick: () => updateFollowUpStatus(match, "callback"),
        className: "border border-amber-200 text-amber-700 hover:bg-amber-50",
        mobileClassName: "bg-amber-500 text-white hover:bg-amber-600",
      },
      {
        id: "not_responding",
        label: "Move to Not Responding",
        onClick: () => updateFollowUpStatus(match, "not_responding"),
        className: "border border-rose-200 text-rose-700 hover:bg-rose-50",
        mobileClassName: "bg-rose-600 text-white hover:bg-rose-700",
      },
    ];
  },
});
